module.exports = __webpack_public_path__ + "img/map-icon.dab6f972.svg";